// Приём структурных блоков ленты. Чистый модуль (DOM нет) — тестируется в
// изоляции (blocks.test.mjs), как theme.ts.
//
// ЗАЧЕМ: public/widget.js кешируется браузерами на ЧУЖИХ сайтах, а сервер
// добавляет новые типы блоков (возможности сотрудника) в своём темпе. Значит
// старый бандл обязан пережить незнакомый тип — тихо пропустить его, а не
// отрисовать мусором и не упасть посреди ленты.
import type { ChatBlock, SwitchBlock } from './api';

/** Типы, которые эта версия бандла умеет рисовать. */
const RENDERABLE = ['roster', 'gallery', 'shop', 'payment', 'actions', 'quick'];

/** Блок пригоден к отрисовке: тип известен И items — массив (сервер новее нас
 *  мог прислать и знакомый тип с другой формой). Всё прочее — молча мимо.
 *  'switch' сюда не входит намеренно: он не рисуется, а меняет адресата ленты
 *  (см. pickSwitch), и тип это фиксирует — забыть про него нельзя. */
export function isRenderableBlock(block: unknown): block is Exclude<ChatBlock, SwitchBlock> {
  if (typeof block !== 'object' || block === null) return false;

  const { type, items } = block as { type?: unknown; items?: unknown };
  return typeof type === 'string' && RENDERABLE.includes(type) && Array.isArray(items);
}

/** Передача разговора коллеге (§8): блок без items — рисовать его нечем, он
 *  МЕНЯЕТ АДРЕСАТА ленты. Поэтому вынут из общего разбора отдельной функцией:
 *  isRenderableBlock его намеренно не пропускает.
 *
 *  Проверяем форму, а не доверяем типу: key должен быть непустой строкой —
 *  иначе виджет ушёл бы поллить `/widget/undefined/messages` и молча замолчал. */
export function pickSwitch(blocks: unknown): SwitchBlock | null {
  if (!Array.isArray(blocks)) return null;

  const found = blocks.find((block) => {
    if (typeof block !== 'object' || block === null) return false;
    const { type, key } = block as { type?: unknown; key?: unknown };
    return type === 'switch' && typeof key === 'string' && key.length > 0;
  });
  if (!found) return null;

  const block = found as SwitchBlock;
  return { type: 'switch', key: block.key, text: typeof block.text === 'string' ? block.text : '' };
}
